import {Helmet} from 'react-helmet-async';
// import { Link } from 'react-router-dom';
import {useTranslation} from 'react-i18next';

const Privacy = () => {
    const {t} = useTranslation();

    return (
        <>
            <Helmet>
                <title>Communitism | Participate</title>
                <meta name="description" content="Participate in the Project and our community initiatives."/>
                <meta property="og:title" content="Communitism | Participate" key="ogtitle"/>
                <meta property="og:description"
                      content="Discover more about the Communitism Project, our mission, and how to get involved."
                      key="ogdesc"/>
                <meta property="og:url" content="https://heriscope.communitism.space/about"/>
                <meta name="twitter:card" content="summary_large_image"/>
            </Helmet>

            {/* Icon Section */}
            <div className='simple-page contact-page-container'>
                <div className='row justify-content-center'>

                    <div className="content-area">
                        <h1 className="content-title">{t("Πολιτική Απορρήτου")}</h1>
                        <div className="content-text">
                            <p>Το Communitism σέβεται την ιδιωτικότητα των χρηστών και δεσμεύεται να προστατεύει τα
                                προσωπικά δεδομένα που συλλέγονται μέσω της πλατφόρμας HeriScope. Αυτή η Πολιτική
                                Απορρήτου εξηγεί πώς συλλέγουμε, χρησιμοποιούμε και προστατεύουμε τα δεδομένα σας
                                σύμφωνα με τον Γενικό Κανονισμό Προστασίας Δεδομένων (GDPR) και την ισχύουσα νομοθεσία
                                περί προστασίας προσωπικών δεδομένων.</p>

                            <h2 className="content-sub-title">{t("1. Ποια δεδομένα συλλέγουμε")}</h2>
                            <h5>Όταν χρησιμοποιείτε την πλατφόρμα HeriScope, μπορεί να συλλέξουμε τα παρακάτω προσωπικά
                                δεδομένα:</h5>
                            <ul>
                                <li>Όνομα ή ψευδώνυμο (εφόσον επιλέξετε να εμφανίζεται στη βάση δεδομένων ως φροντιστ@
                                    κτιρίου)
                                </li>
                                <li>Διεύθυνση email (για πιθανή επικοινωνία σχετικά με τη συμβολή σας)</li>
                                <li>Τηλέφωνο (προαιρετικά, για πιθανή επικοινωνία σχετικά με τη συμβολή σας)</li>
                                <li>Πληροφορίες που προσθέτετε για ένα κτίριο σε αχρησία</li>
                                <li>Τεχνικά δεδομένα (όπως διεύθυνση IP, τύπος συσκευής, cookies) για τη βελτίωση της
                                    εμπειρίας χρήστη.
                                </li>
                            </ul>
                            <h2 className="content-sub-title">{t("2. Πώς χρησιμοποιούμε τα δεδομένα σας")}</h2>

                            <h5>Τα δεδομένα που συλλέγουμε χρησιμοποιούνται αποκλειστικά για:</h5>
                            <ul>
                                <li>Την καταγραφή της συνεισφοράς σας στην πλατφόρμα</li>
                                <li>Ενδεχόμενη επικοινωνία για διευκρινίσεις σχετικά με τις πληροφορίες που προσθέσατε
                                </li>
                                <li>Τη βελτίωση της λειτουργικότητας του HeriScope</li>
                                <li>Πληροφορίες που προσθέτετε για ένα κτίριο σε αχρησία</li>
                                <li>Στατιστική ανάλυση για την αξιολόγηση και ανάπτυξη της πλατφόρμας</li>
                            </ul>
                            <p>Τα δεδομένα δεν πωλούνται, ενοικιάζονται ή κοινοποιούνται σε τρίτους χωρίς τη
                                συγκατάθεσή σας, εκτός αν απαιτείται από το νόμο.</p>

                            <h2 className="content-sub-title">{t("3. Χρόνος διατήρησης δεδομένων")}</h2>
                            <p>Τα προσωπικά σας δεδομένα διατηρούνται για όσο διάστημα είναι απαραίτητο για τους
                                σκοπούς της πλατφόρμας. Μπορείτε ανά πάσα στιγμή να ζητήσετε τη διαγραφή ή τροποποίηση
                                των δεδομένων σας.</p>

                            <h2 className="content-sub-title">{t("4. Τα δικαιώματά σας")}</h2>
                            <h5>Σύμφωνα με τον GDPR, έχετε τα εξής δικαιώματα:</h5>
                            <ul>
                                <li>Δικαίωμα πρόσβασης στα δεδομένα σας</li>
                                <li>Δικαίωμα διόρθωσης λανθασμένων ή ελλιπών δεδομένων</li>
                                <li>Δικαίωμα διαγραφής των δεδομένων σας</li>
                                <li>Δικαίωμα περιορισμού επεξεργασίας</li>
                                <li>Δικαίωμα εναντίωσης στην επεξεργασία δεδομένων</li>
                            </ul>
                            <h2 className="content-sub-title">{t("5. Cookies και τεχνολογίες παρακολούθησης")}</h2>
                            <p>Χρησιμοποιούμε cookies για τη βελτίωση της εμπειρίας χρήστη και την ανάλυση της
                                επισκεψιμότητας. Μπορείτε να διαχειριστείτε τις ρυθμίσεις cookies από το πρόγραμμα
                                περιήγησής σας.</p>

                            <h2 className="content-sub-title">{t("6. Αλλαγές στην πολιτική απορρήτου")}</h2>
                            <p>Η παρούσα πολιτική ενδέχεται να ενημερώνεται περιοδικά. Οποιαδήποτε αλλαγή θα
                                ανακοινώνεται στην ιστοσελίδα μας.</p>


                            <p><strong>Για οποιαδήποτε απορία, επικοινωνήστε μαζί μας στο heriscope@communitism.space.</strong></p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Privacy;
